import { AppLoader } from "components";
import { CompanyAdminSidebar } from "modules/companyAdmin";
import { useCurrentPortalUser } from "modules/companyAdmin/hooks";
import { Outlet } from "react-router-dom";

import styles from "./CompanyAdminLayout.module.scss";

const CompanyAdminLayout = () => {
  const { isLoading, isError } = useCurrentPortalUser();

  if (isLoading || isError) return <AppLoader />;

  return (
    <div className={styles.layout}>
      <aside className={styles.layout__sidebar}>
        <CompanyAdminSidebar />
      </aside>
      <main className={styles.layout__content}>
        <Outlet />
      </main>
    </div>
  );
};

export default CompanyAdminLayout;
